import { render, staticRenderFns } from "./ConfigOpeningHours.vue?vue&type=template&id=67313190&"
import script from "./ConfigOpeningHours.vue?vue&type=script&lang=js&"
export * from "./ConfigOpeningHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports